<template>
    <v-card
        class="col-login-left"
        flat
        tile
        dark>
        <v-img
            contain
            class="my-5"
            max-height="25px"
            src="/img/logo.png" />

        <v-row style="width: 100%; flex: none;">
            <v-col
                :md="$vuetify.breakpoint.mdAndUp ? 6 : 12"
                :offset-md="$vuetify.breakpoint.mdAndUp ? 3 : 0"
            >
                <v-form
                    ref="form"
                    @submit.prevent="submit"
                    v-model="valid"
                    method="post">
                    <v-card-title class="font-weight-bold">
                        Sign Up
                    </v-card-title>

                    <v-card-text>
                        <v-subheader class="px-0 font-weight-medium">Account Details</v-subheader>

                        <v-row>
                            <v-col>
                                <v-text-field
                                    outlined
                                    name="first_name"
                                    label="First Name"
                                    v-model="form_data.first_name"
                                    :rules="rules.first_name"
                                    required />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    outlined
                                    name="last_name"
                                    label="Last Name"
                                    v-model="form_data.last_name"
                                    :rules="rules.last_name"
                                    required />
                            </v-col>
                        </v-row>

                        <v-text-field
                            outlined
                            name="email"
                            label="Email"
                            type="email"
                            v-model="form_data.email"
                            :rules="rules.email"
                            required />

                        <v-row>
                            <v-col>
                                <v-text-field
                                    outlined
                                    name="password"
                                    label="Password"
                                    v-model="form_data.password"
                                    :rules="rules.password"
                                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="() => (show_password = !show_password)"
                                    :type="!show_password ? 'password' : 'text'"
                                    required />
                            </v-col>
                            <v-col>
                                <v-text-field
                                    outlined
                                    label="Password Confirmation"
                                    type="password"
                                    data-lpignore="true"
                                    hide-details="auto"
                                    v-model="form_data.password_confirmation"
                                    :rules="rules.password_confirmation"
                                    required />
                            </v-col>
                        </v-row>

                        <v-subheader class="px-0 font-weight-medium">Business Details</v-subheader>

                        <v-text-field
                            outlined
                            name="company"
                            label="Company"
                            v-model="form_data.company" />

                        <v-text-field
                            outlined
                            name="phone"
                            label="Phone"
                            v-model="form_data.phone"
                            :rules="rules.phone"
                            required />

                        <v-row>
                            <v-col>
                                <v-text-field
                                    outlined
                                    name="industry"
                                    label="Industry"
                                    v-model="form_data.industry"
                                    :rules="rules.industry"
                                    required />
                            </v-col>
                            <v-col>
                                <v-select
                                    outlined
                                    v-model="form_data.clients_count"
                                    :items="clients_count_items"
                                    label="Estimate of potential clients"
                                    :rules="rules.phone"
                                    required/>
                            </v-col>
                        </v-row>

                        <v-subheader class="px-0 font-weight-medium">Business Location Details</v-subheader>

                        <v-select
                            v-model="form_data.country"
                            :items="data.countries"
                            :loading="loadingCountries"
                            outlined
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="iso_code"
                            label="Country"
                            :rules="rules.country"
                            required
                        ></v-select>

                        <v-row>
                            <v-col>
                                <v-select
                                    v-model="form_data.state"
                                    :items="data.states"
                                    :loading="loadingStates"
                                    outlined
                                    hide-no-data
                                    hide-selected
                                    item-text="name"
                                    item-value="iso_code"
                                    label="State"
                                    :rules="rules.state"
                                    required
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-select
                                    v-model="form_data.city_id"
                                    :items="data.cities"
                                    :loading="loadingCities"
                                    outlined
                                    hide-no-data
                                    hide-selected
                                    item-text="name"
                                    item-value="id"
                                    label="City"
                                    :rules="rules.city"
                                    required
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="px-4">
                        <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            block
                            dark
                            type="submit">
                            Sign Up
                        </v-btn>
                    </v-card-actions>

                    <v-card-actions class="px-4">
                        <router-link
                            :to="{name: 'login'}"
                            class="white--text font-weight-bold caption mx-auto">
                            Sign in
                        </router-link>
                    </v-card-actions>
                </v-form>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    data() {
        return {
            loading: false,
            loadingCountries: false,
            loadingStates: false,
            loadingCities: false,
            valid: false,
            form_data: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                company: '',
                phone: '',
                industry: '',
                clients_count: '1-100',
                country: null,
                state: null,
                city_id: null,
            },
            show_password: false,
            rules: {
                email: [
                    v => (new Validation(this)).ruleRequired(v, 'Email'),
                    v => (new Validation(this)).ruleEmail(v, 'Email')
                ],
                password: (new Validation(this)).rulePassword(),
                password_confirmation: (new Validation(this)).rulePasswordConfirm(),
                first_name: [
                    v => (new Validation(this)).ruleRequired(v, 'First Name')
                ],
                last_name: [
                    v => (new Validation(this)).ruleRequired(v, 'Last Name')
                ],
                phone: [
                    v => (new Validation(this)).ruleRequired(v, 'Phone')
                ],
                industry: [
                    v => (new Validation(this)).ruleRequired(v, 'Industry')
                ],
                country: [
                    v => (new Validation(this)).ruleRequired(v, 'Country')
                ],
                state: [
                    v => (new Validation(this)).ruleRequired(v, 'State')
                ],
                city: [
                    v => (new Validation(this)).ruleRequired(v, 'City')
                ],
            },
            clients_count_items: [
                '1-100',
                '100-1000',
                '1000+',
            ],
            data: {
                countries: [],
                states: [],
                cities: [],
            }
        };
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
        }),
    },

    watch: {
        'form_data.country'() {
            this.form_data.state = null;
            this.form_data.city = null;

            this.fetchStates();
        },
        'form_data.state'() {
            this.form_data.city = null;

            this.fetchCities();
        },
    },

    mounted() {
        this.fetchCountries();
    },

    methods: {
        ...mapActions({
            register: 'auth/register',
        }),

        fetchCountries() {
            (new DBDropdowns(this))
                .before(() => {
                    this.loadingCountries = true;
                })
                .after(response => {
                    this.loadingCountries = false;

                    this.data.countries = response.data.data;
                })
                .error(error => {
                    this.loadingCountries = false;
                })
                .getCountries()
        },

        fetchStates() {
            (new DBDropdowns(this))
                .addParam('country_iso_code', this.form_data.country)
                .before(() => {
                    this.loadingStates = true;
                })
                .after(response => {
                    this.loadingStates = false;

                    this.data.states = response.data.data;
                })
                .error(error => {
                    this.loadingStates = false;
                })
                .getStates()
        },

        fetchCities() {
            (new DBDropdowns(this))
                .addParam('country_iso_code', this.form_data.country)
                .addParam('state_iso_code', this.form_data.state)
                .before(() => {
                    this.loadingCities = true;
                })
                .after(response => {
                    this.loadingCities = false;

                    this.data.cities = response.data.data;
                })
                .error(error => {
                    this.loadingCities = false;
                })
                .getCities()
        },

        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            this
                .register(this.form_data)
                .then((response) => {
                    (new SuccessAlert(this))
                        .setMessage(response.data.message)
                        .show();

                    this.$router.replace({name: 'home'});
                })
                .catch((error) => {
                    if (error.response.data.message) {
                        (new ErrorAlert(this))
                            .setMessage(error.response.data.message)
                            .show();
                    }

                    this.collect(error.response.data.errors)
                        .values()
                        .each(item => {
                            (new ErrorAlert(this)).simple(item[0]);
                        });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
